import { motion } from 'framer-motion';

import FlyingIcons from './FlyingIcons';
import TextReveal from './TextReveal';

export function Ads({ name, imageUrl }: { name: string; imageUrl: string }) {
	return (
		<div className="flex h-full w-full flex-col items-center justify-center">
			<FlyingIcons />
			<div className="relative z-10 flex flex-col items-center justify-center">
				<TextReveal text={name} />
				<motion.img
					initial={{ scale: 0 }}
					animate={{ scale: [0, 1, 1.2, 1] }}
					transition={{ delay: 1.5 }}
					className="mt-4 max-h-[70%] min-h-[60%]"
					src={imageUrl}
					alt=""
				/>
			</div>
		</div>
	);
}
